<template>
<div id="cardApp" class="app-wrapper">
<!--  无 token 时显示拒绝访问页面 -->
<div v-if="!tokenValid && !loading" class="access-denied">
<div class="denied-content">
<h1>⚠️ Access Denied</h1>
<p>Invalid or missing token. Please contact administrator.</p>
<el-button @click="goHome">Return to Home</el-button>
</div>
</div>
<!--  有 token 时显示正常页面 -->
<div v-else-if="tokenValid" class="main-wrapper">
<main class="content-main">
<img src="@/assets/banner.png" style="width:100%" />
<img src="@/assets/hktcmbg.png" style="width:100%" />
<div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
<h3 style="margin: 0;">Credit Card Application</h3>
</div>
<div class="apply-section">
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Existing Trust Client Application</div>
<div class="apply-desc">Applicable only to customers who do not need to change their existing mobile phone number, mailing address, nationality, or other information with this bank.</div>
</div>
<div class="apply-btn apply-btn-primary" @click="startApplication">Apply Now</div>
</div>
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Approval Status</div>
<div class="apply-desc">Check Credit Card Approval Status</div>
</div>
<div class="apply-btn apply-btn-secondary" @click="openQueryDialog">Check Approval Status</div>
</div>
</div>
<div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
</div>
</main>
<!-- 条款及细则弹窗 -->
<el-dialog :visible.sync="termsVisible" title="Terms and Conditions" width="850px" class="terms-dialog" :close-on-click-modal="false">
<div class="terms-header">HKTCM Global Visa Charge Card Terms and Conditions</div>
<div class="terms-content" ref="termsContentRef" @scroll="handleTermsScroll">
<p><strong>Important Notice! These Terms and Conditions govern your use of the HKTCM Global VISA Charge Card arranged or facilitated by Hong Kong Trust Capital Management Limited (HKTCM) ("the Company," "we," or "us") and its partners. Please read these Terms and Conditions carefully before using the Charge Card. Your use (including activation) of the Card constitutes your acceptance of and agreement to be bound by these Terms and Conditions. Definitions of terms used herein are provided at the end of these Terms and Conditions.</strong></p>
<p><strong>Qualifications and Registration</strong></p>
<p>1.We reserve the right to take the following actions at any time:<br>
a)Modify, update, or alter these terms and conditions; or<br>
b)Charges, fees, or other conditions may apply for the use of this service or any part thereof (subject to reasonable advance notice).<br>
(All of the above shall collectively be referred to as the "Amendments").</p>
<p>2. We may modify these Terms at any time without notice (except as otherwise provided in paragraph (b) above). Any changes to these Terms may be posted on our website or notified to you via email using the email address provided in your account. Therefore, you should regularly review our website, enable receipt of such push notifications, and ensure the email address and other contact information in your account remain up to date. Your continued use of the Services after such changes take effect constitutes your acceptance of those changes.</p>
<p>3.You must:<br>
a)  Existing trust clients of the Company with account assets meeting the corresponding tier threshold.<br>
b)  Have reached the legal age and possess the capacity to enter into contracts under applicable law.<br>
c)	Reside in a jurisdiction determined by the Company and its partners to be eligible for card issuance.<br>
d)  Comply with all applicable laws, including Anti-Money Laundering (AML) and Know Your Customer (KYC) requirements.<br>
e)  Provide all verification and identity documents as requested by the Company or its partners.</p>
<p>4.You agree to ensure that your registration information is accurate and updated in a timely manner. Failure to do so may result in the suspension or termination of your service access privileges.</p>
<p>5.The company reserves the right to modify, suspend, or terminate your access to the services at any time and at its sole discretion.</p>
<p><strong>About Debit Cards</strong></p>
<p>6.This card is a prepaid debit card. Your card account is not a checking or savings account and is not linked to any other account you hold, except for cash sub-accounts within trust accounts. This card is not a gift card and cannot be given to others. This card is not a credit card, so you may not have the same rights associated with credit card transactions. Funds in your card account do not earn interest.</p>
<p>7.You may access your account balance through your debit card. You shall be subject from time to time to these Terms and Conditions and other terms governing your account and the applicable payment network or platform. In the event of any inconsistency between these Terms and other terms, these Terms and Conditions shall prevail in relation to your debit card and any services.</p>
<p>8.The ownership of the charge card in your possession belongs to our company. When our company requests its return in accordance with the relevant terms and conditions, you are obligated to return it.</p>
<p>9.The Company may provide, modify, suspend, revoke, or cancel any service, account card, or your use of the account card at any time without prior notice. The Company may also add, modify, restrict, suspend, revoke, or cancel all or any rights, services, facilities, and privileges related to your account card. Upon cancellation of the account card, the full amount of any transaction made using the account card or authentication factor shall be immediately payable.</p>
<p><strong>Your responsibility</strong></p>
<p>10.Even in the following circumstances, you shall remain liable:<br>
i）You did not sign the sales slip (including where the transaction may be conducted by telephone, mail, electronic means, or direct payment arrangement without requiring a sales slip or your signature); or the signature on the sales slip differs from the signature on your debit card; or<br>
ii）The transaction was not conducted with your consent.</p>
<p>11.The account cardholder shall be responsible for the following matters:<br>
i All transactions made using the credit card and authentication factors (including all related fees and charges), including those made with the cardholder's own credit card and authentication factors and those made with the credit card and authentication factors of any supplementary cardholder; and<br>
ii）The primary cardholder and any supplementary cardholder have failed to comply with these terms and conditions.<br>
a)	The supplementary cardholder shall be responsible for the use of his/her own charge card and authentication factors, but shall not be liable for the use of their charge card or authentication factors by the primary cardholder or any other supplementary cardholder.<br>
b)	Whether or not you are aware of it, you should not use your charge card for any transaction that may violate the laws of any jurisdiction.<br>
c)	Even if your account card has been terminated, you remain responsible for this.</p>
<p>12. You agree that when the debit card or authentication factor is used to conduct, process, or execute any transaction, it shall be deemed that you have authorized and are aware of such use, regardless of whether you have actually authorized and/or are aware of such use of the debit card or authentication factor. The Company shall debit your account for any amount incurred through transactions or processing using the debit card or authentication factor. The Company's records of all transactions conducted using the debit card or authentication factor shall be deemed accurate and final (except for obvious errors), and you agree to be bound by such records.</p>
<p><strong>Safety and Security Measures</strong></p>
<p>13.You should take appropriate security precautions, including the following:<br>
a)	Sign your account card immediately upon receipt.<br>
b)	Safeguard your debit card and mobile device and keep them in your possession at all times. Treat your debit card with the same care you would cash.<br>
c)	After using the ATM, remember to retrieve your debit card.<br>
d)	Ensure that merchants promptly return the charge card to you after completing the charge card transaction.<br>
e)	Keep your authentication factors and device passwords strictly confidential;<br>
f)	When using authentication factors and device passwords, please ensure that neither the authentication factors nor the device passwords are visible to others.<br>
g)	Regularly change your personal password and device passcode;<br>
h)	If your personal password or device passcode has been or may have been viewed by others, you should change it immediately.<br>
i)	Never write down your authentication factors or device passcode, nor record them on your debit card, store them with your debit card, or handle them in any other way that could allow others to use your debit card, authentication factors, or mobile device. You should obscure any records of your authentication factors or device passcode.<br>
j)	Never use easily guessable numbers as your personal password or device passcode (such as ID numbers, birth dates, phone numbers, or other readily accessible personal information) and use alphanumeric codes where applicable;<br>
k)	Do not use the same private password or device password for other services or purposes, such as connecting to the internet or logging into other websites.<br>
l)	Do not transfer your debit card, authentication factors, device passcode, or mobile device, nor permit any other person to use your debit card, authentication factors, device passcode, or mobile device.<br>
m)	Each time you make a purchase, remember to fill in the total amount on the receipt and include the currency code before the amount. Do not leave any spaces for others to fill in.<br>
n)	Ensure that only one receipt is printed per transaction;<br>
o)	Retain the cardholder stub of each credit card transaction slip and reconcile it with the credit card statement or records; and<br>
p)	Please ensure that the contact information you have registered with our company for receiving important notifications (such as SMS and email notifications for online payments) is up to date so that such notifications can be delivered to you in a timely manner.</p>
<p><strong>Report immediately if your account card, authentication factor, or mobile device is lost, stolen, or misused.</strong></p>
<p>14.If your debit card, authentication factor, or mobile device is lost, stolen, compromised, or used without authorization, you must promptly report this to us and provide written confirmation as soon as reasonably practicable. You remain liable for all transactions made using your debit card or authentication factor prior to our receipt of your report.</p>
<p>15.	Without limiting or impairing the effect of Section 17(a), if your account statement shows any transaction not authorized by you, you shall promptly notify the Company. You must submit a chargeback request to the Company within 45 days after the transaction. If you fail to notify us within this 45-day period, the transaction shall be deemed correct, final, and binding upon you, and you shall be deemed to have waived any right to raise objections or seek remedies against us in relation to such transaction.</p>
<p><strong>Your Liability for Unauthorized Transactions</strong></p>
<p>16.	If you report the loss, theft, compromise, or unauthorized use of your debit card, authentication factor, or mobile device under Section 14(b), your liability for unauthorized transactions will be determined on a case-by-case basis.</p>
<p>17.	If you knowingly (whether voluntarily or not) permit any other person to use your debit card, authentication factor, or mobile device; or if you commit fraud or act with gross negligence in the use or custody of your debit card, authentication factor, or mobile device. Failure to implement any security measures recommended by us from time to time regarding the use or custody of your debit card, authentication factor, or mobile device may be deemed gross negligence on your part, and you may be held liable for the transaction amount.</p>
<p><strong>Compensation</strong></p>
<p>18.	To the fullest extent permitted by law, you agree to indemnify and hold harmless the Company (and all its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") from and against any and all claims, demands, actions, proceedings, liabilities, losses, damages, penalties, penalties, fines, expenses, and costs (including reasonable legal fees as determined by a court of competent jurisdiction) incurred by the Company (and all of its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") in connection with:<br>
a)	Your conduct and your use of our services;<br>
b)	You violate these Terms or our Anti-Money Laundering ("AML") policy;<br>
c)	You violate any law, regulation, or rule;<br>
d)	You violate or infringe upon the Company's copyrights, intellectual property rights, trade secrets, patents, trademarks, service marks, or any other legally protected proprietary rights;<br>
e)	You have failed to properly safeguard or maintain the confidentiality of your account card credentials or any other identity verification data as required under Article 16;<br>
f)	Any damages caused by you to our services, any user, or any other individual or entity; or<br>
g)	Any rights exercised by the Company pursuant to these terms.</p>
<p>19.	This indemnification includes, but is not limited to, liabilities related to intellectual property, defamation, and invasion of privacy.</p>
<p><strong>Disclaimer and Exceptions</strong></p>
<p>20.	The Company shall not be liable to you or any other person for any of the following (or any one thereof):<br>
a)	Any failure or delay by the Company in providing any services, equipment, or other facilities to you that may be attributable to circumstances beyond the Company's reasonable control;<br>
b)	The availability or performance of any point-of-sale terminal or other device provided or operated by a merchant or any other person for the use of a charge card or any of its features (including contactless payment functionality); and<br>
c)	Consequential or indirect losses arising from or in connection with the use of your debit card or authentication factor.</p>
<p>21The Company shall not be liable for any merchant's refusal to accept your charge card or authentication factor. The Company shall also not be liable for any goods or services provided to you by any merchant. Your obligations to the Company under these Terms and Conditions shall not be affected, waived, or reduced by any claim you may have against a merchant. You shall be solely responsible for resolving any disputes with merchants. In particular, you and the merchant must agree to establish, modify, or terminate any automatic transfer or direct debit arrangement for charging payments to your account. In the event of any dispute between you and the merchant, the Company reserves the right not to execute any request to establish, modify, or terminate such arrangements.</p>
<p>22.Even if any merchant fails to provide goods or services or fails to fulfill its obligations, or if any goods or services provided by any merchant are defective, or if any merchant fails to provide you with any goods, services, offers, discounts, or programs, the Company reserves the right to deduct from your account all transactions made using your charge card or authentication factors. You must seek redress directly from the relevant merchant regarding such goods, services, offers, discounts, or programs.</p>
<p>23.	The Company reserves the right to convert the refund amount into another currency at a time and exchange rate deemed appropriate by the Company. You shall bear all related exchange rate risks, losses, commissions, and other charges and fees.</p>
<p>24.	Under no circumstances shall the Company, its affiliates, service providers, or any of their respective officers, directors, agents, partners, employees, or representatives be liable for:<br>
a)	Any loss of profits, goodwill or reputation, loss of data, impairment of value or business opportunities, loss, damage, deterioration, or disclosure of any data or other intangible property, or any special, incidental, indirect, intangible, or consequential damages arising out of or in connection with the use of the Company's website or services or this Agreement, whether based on contract, tort, negligence, strict liability, or otherwise, even if the Company has been advised of, knew of, or ought to have known of the possibility of such damages, and even if any agreed-upon or other remedy fails of its essential purpose. The Company shall not be liable for such damages unless a final judicial determination establishes that such damages resulted from the Company's gross negligence, fraud, or intentional misconduct, or intentional violation of law.</p>
<p><strong>Governing Law and Dispute Resolution</strong></p>
<p>25.	These terms shall be governed by and construed in accordance with the laws of Hong Kong, without regard to its conflict of laws principles.</p>
<p>26.	If you are a consumer and have any complaints, we encourage you to first contact our customer service team via our website www.hongkongtrust.com.hk and email info@hktcm.com.</p>
<p>27.	If the complaint is not resolved to your satisfaction, you may refer the matter to the Hong Kong Mediation and Arbitration Centre for mediation, followed by arbitration at the Hong Kong International Arbitration Centre in accordance with its then-current Arbitration Rules ("HKIAC Rules"). Should mediation fail, such rules shall be deemed incorporated by reference into these Terms.</p>
<p>28.	The language of the arbitration shall be English. The place of arbitration shall be Hong Kong. Unless otherwise determined by the arbitral tribunal, each party shall bear its own arbitration costs.</p>
</div>
<div class="terms-footer">
<div class="terms-checkbox">
<input type="checkbox" id="termsAgree" v-model="termsAgreed" :disabled="!canAgree">
<label for="termsAgree" class="terms-checkbox-label">
I confirm that I have read and agree to the 'HKTCM Global Visa Charge Card Terms and Conditions.'<br>
<span>Please check this box to confirm you have read and agree to the terms before proceeding with the application.</span>
</label>
</div>
<div class="terms-actions">
<el-button @click="closeTermsDialog" class="terms-cancel">Cancel</el-button>
<el-button @click="acceptTerms" :disabled="!termsAgreed" class="terms-accept">Accept</el-button>
</div>
</div>
</el-dialog>
<!-- 申请表单弹窗 -->
<el-dialog :visible.sync="applicationFormVisible" title="Credit Card Application Form" class="application-form-dialog" width="1400px" append-to-body>
<div class="step-nav">
<div class="step">
<div class="step-number" :class="{ 'active': currentStep === 1 }">1</div>
<div class="step-label" :class="{ 'active': currentStep === 1 }">Applicant & Account</div>
</div>
<div class="step-connector" :class="{ 'active': currentStep >= 2 }"></div>
<div class="step">
<div class="step-number" :class="{ 'active': currentStep === 2 }">2</div>
<div class="step-label" :class="{ 'active': currentStep === 2 }">Cardholder Information</div>
</div>
</div>
<div v-if="currentStep === 1" class="form-section">
<h3 class="section-title">Applicant and Trust Account Information</h3>
<div class="preview-title" style="margin-bottom: 20px;">
Applicant: {{ formData.Name }}
</div>
<!-- 第一组：基本身份信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid">
<div class="form-group">
<label class="form-label">Trust account number</label>
<el-input v-model="formData.username" readonly class="form-input readonly-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Name (Legal)</label>
<el-input v-model="formData.Name" placeholder="Please enter your name" class="form-input readonly-input" readonly></el-input>
</div>
<div class="form-group">
<label class="form-label">English Name</label>
<el-input v-model="formData.englishName" placeholder="Please enter English name" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Gender</label>
<el-select v-model="formData.gender" placeholder="Please select" class="form-input title-select readonly-input" readonly>
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Nationality</label>
<el-input v-model="formData.nationality" placeholder="Please enter your nationality" class="form-input readonly-input" readonly></el-input>
</div>
<div class="form-group">
<label class="form-label">Date of Birth</label>
<el-date-picker v-model="formData.dateOfBirth" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">National Identity Card Number/Passport <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.idNumber" placeholder="Please enter your identification number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Type</label>
<el-select v-model="formData.idType" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
</div>
<!-- 第二组：证件详细信息 -->
<div class="form-group-title" style="margin-top: 25px;">ID Document Details</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">ID Issue Date</label>
<el-date-picker v-model="formData.idIssueDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" v-if="formData.idType !== 'HKID' && formData.idType !== 'Other'">
<label class="form-label">ID Expiry Date <span style="color: #EF4444;">*</span></label>
<el-date-picker v-model="formData.idExpiryDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">ID Card Address</label>
<el-input v-model="formData.idAddress" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>
<!-- 第三组：证件上传 -->
<div class="form-group-title" style="margin-top: 25px;">ID Document Upload</div>
<div class="upload-section" style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px;">
<div class="upload-notice" style="margin-bottom: 15px; color: #666; font-size: 13px;">
<strong>📋 Upload Requirements:</strong>
<ul style="margin: 8px 0 0 20px; padding: 0;">
<li>Mainland ID: Front (Portrait) + Back (Emblem) pages required</li>
<li>HK ID: Information page required</li>
<li>Passport/Other: Information page required</li>
<li>File format: JPG, PNG, or PDF | Max size: 5MB per file</li>
</ul>
</div>
<div class="part-a-grid">
<div class="form-group" v-if="formData.idType === 'MainlandID'">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl', 'idDocFrontFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocFrontFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'MainlandID'">
<label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl', 'idDocBackFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocBackFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'HKID'">
<label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
</div>
<div class="form-group" v-if="formData.idType === 'Passport' || formData.idType === 'Other'">
<label class="form-label">Passport/ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
<el-button size="small" type="primary">Upload Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
</div>
</div>
</div>
<!-- 第四组：联系信息 -->
<div class="form-group-title" style="margin-top: 25px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Telephone</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+886 TW" value="+886" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
<el-option label="+81 JP" value="+81" />
</el-select>
<el-input v-model="formData.phone" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address</label>
<el-input v-model="formData.email" placeholder="Please enter your email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address (Mailing)</label>
<el-input v-model="formData.address" type="textarea" :rows="2" placeholder="Please enter your full postal address" class="form-input required-input"></el-input>
</div>
</div>
<!-- 第五组：职业与合规信息 -->
<div class="form-group-title" style="margin-top: 25px;">Professional & Compliance Information</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Occupation Type</label>
<el-select v-model="formData.occupation" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position</label>
<el-select v-model="formData.jobTitle" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service</label>
<el-input v-model="formData.yearsOfService" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income</label>
<el-input v-model="formData.yearlyIncome" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name</label>
<el-input v-model="formData.companyName" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address</label>
<el-input v-model="formData.officeAddress" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+886 TW" value="+886" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
<el-option label="+81 JP" value="+81" />
</el-select>
<el-input v-model="formData.officeTel" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account</label>
<el-select v-model="formData.accountPurpose" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth</label>
<el-select v-model="formData.sourceOfWealth" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth === 'Others'">
<label class="form-label">Source of Wealth (Please note)</label>
<el-input v-model="formData.sourceOfWealthOther" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>
</div>
<div v-if="currentStep === 2" class="form-section">
<h3 class="section-title">Account Card Distribution Information</h3>
<div style="font-size: 14px; margin-bottom: 20px; color: var(--text-secondary);">
Account cards will be issued to (name must not exceed 20 characters, including spaces)
</div>
<!-- ============ 主卡 ============ -->
<div style="margin-bottom: 25px;">
<div style="font-weight: bold; margin-bottom: 8px;">Name on the account card</div>
<div style="font-size: 13px; color: var(--text-secondary); margin-bottom: 8px;">
Names must be provided in English only (e.g., John Smith). Chinese characters, numbers, or special symbols are not permitted.
</div>
<div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
<span style="min-width: 100px;">Primary cardholder:</span>
<div style="flex: 1; position: relative;">
<el-input v-model="formData.cardName1" @input="handleCardName1Input" placeholder="Please enter English name only (e.g. John Smith)" class="form-input" :class="{ 'required-input': formData.cardName1 && formData.cardName1.trim() }"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName1 ? formData.cardName1.length : 0)" style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">{{ formData.cardName1 ? formData.cardName1.length : 0 }}/20</span>
</div>
</div>
<div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="option.value" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType1" :value="option.value" :name="'cardType1'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType1" class="card-preview">
<img :src="getCardImage(formData.cardType1, formData.showLogoOnCard1)" alt="Credit Card Preview"/>
<div v-if="formData.showNameOnCard1" class="name-overlay" :style="{ color: formData.cardType1 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName1 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType1" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard1"> Display cardholder's name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard1"> Display bank logo
</label>
</div>
<!-- ✅ 主卡电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Primary Cardholder</div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply Entrust Credit Card in Hong Kong and aged 18 or above. 宇信數碼信用卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Entrust Digital Limited (Entrust). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Entrust to review the accuracy and authenticity of all information on this Application Form, and Entrust shall have full power to accept the application.<br>本人同意及授權宇信數碼有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意宇信數碼有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Entrust.<br>本人已閱讀、明白及同意宇信數碼有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a Entrust Credit Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立宇信數碼信用卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad1"
v-model="formData.signatureData1"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(1, $event)"
/>
</div>
<!-- <div style="display: flex; flex-direction: column; gap: 10px;">
<el-button size="small" @click="clearSignature(1)" type="warning">Clear Signature</el-button>
<div v-if="formData.isSigned1" style="font-size: 12px; color: #10b981; text-align: center;">✓ Signed</div>
</div> -->
</div>
</div>
</div>
<!-- 添加附属卡按钮 -->
<div style="margin-bottom: 20px;">
<el-button type="text" @click="toggleCard2" style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;">
{{ formData.showCard2 ? '▲ Close supplementary card' : '➕ Add an additional card' }}
</el-button>
</div>
<!-- ============ 附属卡 1 ============ -->
<div v-if="formData.showCard2" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
<div style="font-weight: bold; margin-bottom: 15px; font-size: 15px; color: var(--primary-color);">📇 Supplementary Card 1 - Cardholder Information</div>
<!-- 基本信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Cardholder Name (Chinese)</label>
<el-input v-model="formData.cardName2Chinese" placeholder="Please enter Chinese name" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Cardholder Name (English)</label>
<el-input v-model="formData.cardName2" @input="handleCardName2Input" placeholder="Please enter English name only" class="form-input required-input"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName2 ? formData.cardName2.length : 0)" style="font-size: 11px; color: #666;">{{ formData.cardName2 ? formData.cardName2.length : 0 }}/20</span>
</div>
<div class="form-group">
<label class="form-label">Gender</label>
<el-select v-model="formData.gender2" placeholder="Please select" class="form-input required-input">
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Nationality</label>
<el-select v-model="formData.nationality2" filterable placeholder="Please select" class="form-input required-input">
<el-option v-for="country in countryList" :key="country.code" :label="country.name" :value="country.name" />
</el-select>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Date of Birth</label>
<el-date-picker v-model="formData.dateOfBirth2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">ID Type</label>
<el-select v-model="formData.idType2" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange2">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">ID Number</label>
<el-input v-model="formData.idNumber2" placeholder="ID or Passport Number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Issue Date</label>
<el-date-picker v-model="formData.idIssueDate2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">ID Expiry Date</label>
<el-date-picker v-model="formData.idExpiryDate2" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 3;">
<label class="form-label">ID Card Address</label>
<el-input v-model="formData.idAddress2" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>
<!-- 证件上传 -->
<div class="form-group-title" style="margin-top: 20px;">ID Document Upload</div>
<div style="margin-top: 15px; padding: 15px; background: #f0f0f0; border-radius: 6px;">
<div class="part-a-grid">
<div v-if="formData.idType2 === 'MainlandID'" class="form-group">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList2" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl2', 'idDocFrontFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType2 === 'MainlandID'" class="form-group">
<label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList2" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl2', 'idDocBackFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType2 === 'HKID' || formData.idType2 === 'Passport' || formData.idType2 === 'Other'" class="form-group">
<label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList2" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl2', 'idDocInfoFileList2')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList2.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
</div>
</div>
<!-- 联系信息 -->
<div class="form-group-title" style="margin-top: 20px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Telephone</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode2" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+886 TW" value="+886" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
<el-option label="+81 JP" value="+81" />
</el-select>
<el-input v-model="formData.phone2" @input="handlePhoneInput(2, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address</label>
<el-input v-model="formData.email2" placeholder="Email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address</label>
<el-input v-model="formData.address2" type="textarea" :rows="2" placeholder="Full postal address" class="form-input required-input"></el-input>
</div>
</div>
<!-- 职业与合规 -->
<div class="form-group-title" style="margin-top: 20px;">Professional & Compliance Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Occupation Type</label>
<el-select v-model="formData.occupation2" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position</label>
<el-select v-model="formData.jobTitle2" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service</label>
<el-input v-model="formData.yearsOfService2" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income</label>
<el-input v-model="formData.yearlyIncome2" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name</label>
<el-input v-model="formData.companyName2" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address</label>
<el-input v-model="formData.officeAddress2" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode2" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+886 TW" value="+886" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
<el-option label="+81 JP" value="+81" />
</el-select>
<el-input v-model="formData.officeTel2" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account</label>
<el-select v-model="formData.accountPurpose2" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange2">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth</label>
<el-select v-model="formData.sourceOfWealth2" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange2">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth2 === 'Others'">
<label class="form-label">Source of Wealth (Please note)</label>
<el-input v-model="formData.sourceOfWealthOther2" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>
<!-- 卡片设置 -->
<div class="form-group-title" style="margin-top: 20px;">Card Settings</div>
<div style="display: flex; align-items: center; gap: 16px; margin-top: 15px; margin-left: 0;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="`2-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType2" :value="option.value" :name="'cardType2'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType2" class="card-preview" style="margin-top: 15px;">
<img :src="getCardImage(formData.cardType2, formData.showLogoOnCard2)" alt="Credit Card Preview"/>
<div v-if="formData.showNameOnCard2" class="name-overlay" :style="{ color: formData.cardType2 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName2 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType2" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard2"> Display cardholder's name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard2"> Display bank logo
</label>
</div>
<!-- ✅ 附属卡 1 电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Supplementary Cardholder 1</div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply Entrust Credit Card in Hong Kong and aged 18 or above. 宇信數碼信用卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Entrust Digital Limited (Entrust). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Entrust to review the accuracy and authenticity of all information on this Application Form, and Entrust shall have full power to accept the application.<br>本人同意及授權宇信數碼有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意宇信數碼有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Entrust.<br>本人已閱讀、明白及同意宇信數碼有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a Entrust Credit Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立宇信數碼信用卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad2"
v-model="formData.signatureData2"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(2, $event)"
/>
</div>
<div style="display: flex; flex-direction: column; gap: 10px;">
<el-button size="small" @click="clearSignature(2)" type="warning">Clear Signature</el-button>
<div v-if="formData.isSigned2" style="font-size: 12px; color: #10b981; text-align: center;">✓ Signed</div>
</div>
</div>
</div>
<!-- 附属卡 1 额度设置 -->
<div class="form-group-title" style="margin-top: 20px;">💳 Credit Limit Setting</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Credit Limit (HKD) <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.creditLimit2" placeholder="e.g. 50000" class="form-input required-input"></el-input>
</div>
</div>
</div>
<!-- 添加第二张附属卡 -->
<div v-if="formData.showCard2" style="margin-bottom: 20px;">
<el-button type="text" @click="toggleCard3" style="color: var(--primary-color); padding: 0; height: auto; font-size: 14px;">
{{ formData.showCard3 ? '▲ Retract the second supplementary card' : '➕ Add a second supplementary card' }}
</el-button>
</div>
<!-- ============ 附属卡 2 ============ -->
<div v-if="formData.showCard3" style="margin-bottom: 25px; padding: 16px; background: #fafafa; border-radius: 8px;">
<div style="font-weight: bold; margin-bottom: 15px; font-size: 15px; color: var(--primary-color);">📇 Supplementary Card 2 - Cardholder Information</div>
<!-- 基本信息 -->
<div class="form-group-title">Basic Identity Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Cardholder Name (Chinese)</label>
<el-input v-model="formData.cardName3Chinese" placeholder="Please enter Chinese name" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Cardholder Name (English)</label>
<el-input v-model="formData.cardName3" @input="handleCardName3Input" placeholder="Please enter English name only" class="form-input required-input"></el-input>
<span class="char-counter" :class="getCharCountClass(formData.cardName3 ? formData.cardName3.length : 0)" style="font-size: 11px; color: #666;">{{ formData.cardName3 ? formData.cardName3.length : 0 }}/20</span>
</div>
<div class="form-group">
<label class="form-label">Gender</label>
<el-select v-model="formData.gender3" placeholder="Please select" class="form-input required-input">
<el-option label="Male" value="male"></el-option>
<el-option label="Female" value="female"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Nationality</label>
<el-select v-model="formData.nationality3" filterable placeholder="Please select" class="form-input required-input">
<el-option v-for="country in countryList" :key="country.code" :label="country.name" :value="country.name" />
</el-select>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Date of Birth</label>
<el-date-picker v-model="formData.dateOfBirth3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group">
<label class="form-label">ID Type</label>
<el-select v-model="formData.idType3" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange3">
<el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
<el-option label="Hong Kong Identity Card" value="HKID"></el-option>
<el-option label="Passport" value="Passport"></el-option>
<el-option label="Other" value="Other"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">ID Number</label>
<el-input v-model="formData.idNumber3" placeholder="ID or Passport Number" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">ID Issue Date</label>
<el-date-picker v-model="formData.idIssueDate3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">ID Expiry Date</label>
<el-date-picker v-model="formData.idExpiryDate3" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
</div>
<div class="form-group" style="grid-column: span 3;">
<label class="form-label">ID Card Address</label>
<el-input v-model="formData.idAddress3" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
</div>
</div>
<!-- 证件上传 -->
<div class="form-group-title" style="margin-top: 20px;">ID Document Upload</div>
<div style="margin-top: 15px; padding: 15px; background: #f0f0f0; border-radius: 6px;">
<div class="part-a-grid">
<div v-if="formData.idType3 === 'MainlandID'" class="form-group">
<label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocFrontFileList3" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl3', 'idDocFrontFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Front</el-button>
</el-upload>
<div v-if="formData.idDocFrontFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType3 === 'MainlandID'" class="form-group">
<label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocBackFileList3" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl3', 'idDocBackFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload Back</el-button>
</el-upload>
<div v-if="formData.idDocBackFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
<div v-if="formData.idType3 === 'HKID' || formData.idType3 === 'Passport' || formData.idType3 === 'Other'" class="form-group">
<label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
<el-upload action="#" :file-list="formData.idDocInfoFileList3" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl3', 'idDocInfoFileList3')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf">
<el-button size="small" type="primary">Upload ID Page</el-button>
</el-upload>
<div v-if="formData.idDocInfoFileList3.length > 0" style="font-size: 11px; color: #10b981; margin-top: 3px;">✓ Uploaded</div>
</div>
</div>
</div>
<!-- 联系信息 -->
<div class="form-group-title" style="margin-top: 20px;">Contact Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Telephone</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.phoneCode3" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="+852" />
<el-option label="+86 CN" value="+86" />
<el-option label="+886 TW" value="+886" />
<el-option label="+1 US/CA" value="+1" />
<el-option label="+44 UK" value="+44" />
<el-option label="+61 AU" value="+61" />
<el-option label="+81 JP" value="+81" />
</el-select>
<el-input v-model="formData.phone3" @input="handlePhoneInput(3, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Email address</label>
<el-input v-model="formData.email3" placeholder="Email address" type="email" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Postal Address</label>
<el-input v-model="formData.address3" type="textarea" :rows="2" placeholder="Full postal address" class="form-input required-input"></el-input>
</div>
</div>
<!-- 职业与合规 -->
<div class="form-group-title" style="margin-top: 20px;">Professional & Compliance Information</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Occupation Type</label>
<el-select v-model="formData.occupation3" placeholder="Select Occupation" class="form-input required-input">
<el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Position</label>
<el-select v-model="formData.jobTitle3" placeholder="Select Position" class="form-input required-input">
<el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Years of Service</label>
<el-input v-model="formData.yearsOfService3" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
</div>
<div class="form-group">
<label class="form-label">Yearly Income</label>
<el-input v-model="formData.yearlyIncome3" placeholder="e.g. 500000" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Company Name</label>
<el-input v-model="formData.companyName3" placeholder="Please enter company name" class="form-input required-input"></el-input>
</div>
<div class="form-group" style="grid-column: span 2;">
<label class="form-label">Office Address</label>
<el-input v-model="formData.officeAddress3" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
</div>
</div>
<div class="part-a-grid" style="margin-top: 20px;">
<div class="form-group">
<label class="form-label">Office Tel. No.</label>
<div style="display:flex; gap:8px;">
<el-select v-model="formData.officeTelCode3" filterable placeholder="Code" style="width: 100px;" class="form-input">
<el-option label="+852 HK" value="852" />
<el-option label="+86 CN" value="86" />
<el-option label="+886 TW" value="886" />
<el-option label="+1 US/CA" value="1" />
<el-option label="+44 UK" value="44" />
<el-option label="+61 AU" value="61" />
<el-option label="+81 JP" value="81" />
</el-select>
<el-input v-model="formData.officeTel3" placeholder="Office number" class="form-input required-input"></el-input>
</div>
</div>
<div class="form-group">
<label class="form-label">Purpose of Account</label>
<el-select v-model="formData.accountPurpose3" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange3">
<el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group">
<label class="form-label">Source of Wealth</label>
<el-select v-model="formData.sourceOfWealth3" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange3">
<el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
</el-select>
</div>
<div class="form-group" v-if="formData.sourceOfWealth3 === 'Others'">
<label class="form-label">Source of Wealth (Please note)</label>
<el-input v-model="formData.sourceOfWealthOther3" placeholder="Please specify" class="form-input required-input"></el-input>
</div>
</div>
<!-- 卡片设置 -->
<div class="form-group-title" style="margin-top: 20px;">Card Settings</div>
<div style="display: flex; align-items: center; gap: 16px; margin-top: 15px; margin-left: 0;">
<span>Application Category:</span>
<template v-for="option in availableCardTypes">
<label :key="`3-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
<input type="radio" v-model="formData.cardType3" :value="option.value" :name="'cardType3'"> {{ option.label }}
</label>
</template>
</div>
<div v-if="formData.cardType3" class="card-preview" style="margin-top: 15px;">
<img :src="getCardImage(formData.cardType3, formData.showLogoOnCard3)" alt="Credit Card Preview"/>
<div v-if="formData.showNameOnCard3" class="name-overlay" :style="{ color: formData.cardType3 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName3 || 'Contact Information' }}</div>
</div>
<div v-if="formData.cardType3" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showNameOnCard3"> Display cardholder's name
</label>
<label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
<input type="checkbox" v-model="formData.showLogoOnCard3"> Display bank logo
</label>
</div>
<!-- ✅ 附属卡 2 电子签名 - 使用 SignaturePad 组件 -->
<div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
<div class="form-group-title" style="margin-top: 0;">Electronic Signature - Supplementary Cardholder 2</div>
<div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
<p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
<strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
<ul style="padding-left: 20px; margin: 0;">
<li style="margin-bottom: 8px;">Applicant must apply Entrust Credit Card in Hong Kong and aged 18 or above. 宇信數碼信用卡申請人須為年滿 18 歲及在香港申請。</li>
<li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Entrust Digital Limited (Entrust). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
<li style="margin-bottom: 8px;">I agree and authorize Entrust to review the accuracy and authenticity of all information on this Application Form, and Entrust shall have full power to accept the application.<br>本人同意及授權宇信數碼有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意宇信數碼有限公司持最終審批權；</li>
<li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Entrust.<br>本人已閱讀、明白及同意宇信數碼有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
<li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a Entrust Credit Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立宇信數碼信用卡。</li>
</ul>
</div>
<div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
<div style="flex: 1; min-width: 300px;">
<SignaturePad
ref="sigPad3"
v-model="formData.signatureData3"
title="Please sign above"
:width="500"
:height="200"
@input="handleSignatureUpdate(3, $event)"
/>
</div>
<div style="display: flex; flex-direction: column; gap: 10px;">
<el-button size="small" @click="clearSignature(3)" type="warning">Clear Signature</el-button>
<div v-if="formData.isSigned3" style="font-size: 12px; color: #10b981; text-align: center;">✓ Signed</div>
</div>
</div>
</div>
<!-- 附属卡 2 额度设置 -->
<div class="form-group-title" style="margin-top: 20px;">💳 Credit Limit Setting</div>
<div class="part-a-grid" style="margin-top: 15px;">
<div class="form-group">
<label class="form-label">Credit Limit (HKD) <span style="color: #EF4444;">*</span></label>
<el-input v-model="formData.creditLimit3" placeholder="e.g. 50000" class="form-input required-input"></el-input>
</div>
</div>
</div>
</div>
<div class="form-footer" slot="footer">
<el-button v-if="currentStep > 1" @click="prevStep" class="form-btn btn-prev">Previous step</el-button>
<el-button v-if="currentStep < 2" @click="nextStep" class="form-btn btn-next">Next step</el-button>
<el-button v-if="currentStep === 2" type="primary" @click="submitApplication" class="form-btn btn-submit">Submit an application</el-button>
</div>
</el-dialog>
<!-- 预览确认弹窗 -->
<el-dialog :visible.sync="previewVisible" title="Application Information Preview" width="1000px" :append-to-body="true">
<div v-if="previewData" class="preview-content">
<h3 style="text-align: center; margin-bottom: 20px;">HKTCM Credit Card Application Form</h3>
<h4 class="section-title">Applicant Information</h4>
<table class="preview-table">
<tr><th>Trust account number:</th><td>{{ previewData.username || 'N/A' }}</td></tr>
<tr><th>Name:</th><td>{{ previewData.Name }}</td></tr>
<tr><th>English Name:</th><td>{{ previewData.englishName || 'N/A' }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType === 'MainlandID'">Front: {{ previewData.idDocFrontFileList?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode }} {{ previewData.phone || 'N/A' }}</td></tr>
<tr><th>Email address:</th><td>{{ previewData.email || 'N/A' }}</td></tr>
<tr><th>Postal Address:</th><td>{{ previewData.address || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode }} {{ previewData.officeTel || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth || 'N/A' }} {{ previewData.sourceOfWealthOther ? '(' + previewData.sourceOfWealthOther + ')' : '' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned1 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
<h4 class="section-title">Primary Card Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name:</th><td>{{ previewData.cardName1 || 'N/A' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType1 ? cardTypeLabels[previewData.cardType1] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard1) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard1) }}</td></tr>
</table>
<template v-if="previewData.cardName2 && previewData.cardName2.trim()">
<h4 class="section-title">Supplementary Card 1 Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name (Chinese):</th><td>{{ previewData.cardName2Chinese || 'N/A' }}</td></tr>
<tr><th>Cardholder Name (English):</th><td>{{ previewData.cardName2 }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender2 || 'N/A' }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality2 || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth2 || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType2 || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber2 || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate2 || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate2 || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress2 || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType2 === 'MainlandID'">Front: {{ previewData.idDocFrontFileList2?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList2?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList2?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode2 }} {{ previewData.phone2 || 'N/A' }}</td></tr>
<tr><th>Email:</th><td>{{ previewData.email2 || 'N/A' }}</td></tr>
<tr><th>Address:</th><td>{{ previewData.address2 || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation2 || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle2 || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService2 || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome2 || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName2 || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress2 || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode2 }} {{ previewData.officeTel2 || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose2 || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth2 || 'N/A' }} {{ previewData.sourceOfWealthOther2 ? '(' + previewData.sourceOfWealthOther2 + ')' : '' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType2 ? cardTypeLabels[previewData.cardType2] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard2) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard2) }}</td></tr>
<tr><th>Credit Limit:</th><td>{{ previewData.creditLimit2 || 'N/A' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned2 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
</template>
<template v-if="previewData.cardName3 && previewData.cardName3.trim()">
<h4 class="section-title">Supplementary Card 2 Information</h4>
<table class="preview-table">
<tr><th>Cardholder Name (Chinese):</th><td>{{ previewData.cardName3Chinese || 'N/A' }}</td></tr>
<tr><th>Cardholder Name (English):</th><td>{{ previewData.cardName3 }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender3 || 'N/A' }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality3 || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth3 || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType3 || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber3 || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate3 || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate3 || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress3 || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType3 === 'MainlandID'">Front: {{ previewData.idDocFrontFileList3?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList3?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList3?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode3 }} {{ previewData.phone3 || 'N/A' }}</td></tr>
<tr><th>Email:</th><td>{{ previewData.email3 || 'N/A' }}</td></tr>
<tr><th>Address:</th><td>{{ previewData.address3 || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation3 || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle3 || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService3 || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome3 || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName3 || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress3 || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode3 }} {{ previewData.officeTel3 || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose3 || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth3 || 'N/A' }} {{ previewData.sourceOfWealthOther3 ? '(' + previewData.sourceOfWealthOther3 + ')' : '' }}</td></tr>
<tr><th>Card Type:</th><td>{{ previewData.cardType3 ? cardTypeLabels[previewData.cardType3] : 'N/A' }}</td></tr>
<tr><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard3) }}</td></tr>
<tr><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard3) }}</td></tr>
<tr><th>Credit Limit:</th><td>{{ previewData.creditLimit3 || 'N/A' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.isSigned3 ? '✓ Signed' : '✗ Not Signed' }}</td></tr>
</table>
</template>
</div>
<div slot="footer" class="dialog-footer">
<el-button @click="previewVisible = false">Return to edit</el-button>
<el-button type="primary" @click="confirmAndSubmit">Confirm and submit</el-button>
</div>
</el-dialog>
<!-- 批核查询弹窗 -->
<el-dialog :visible.sync="queryVisible" title="Check the approval status" width="500px" class="query-dialog">
<el-form :model="queryForm" label-position="left" label-width="150px">
<el-form-item label="Methods:">
<el-radio-group v-model="queryForm.type">
<el-radio label="trust">Trust</el-radio>
<el-radio label="id">Document Number</el-radio>
</el-radio-group>
</el-form-item>
<el-form-item :label="queryForm.type === 'trust' ? 'Trust:' : 'Document:'">
<el-input v-model="queryForm.value" class="login-input"></el-input>
</el-form-item>
<el-form-item label="ImageCap:">
<div style="display: flex; align-items: center; gap: 10px;">
<el-input v-model="queryForm.captchaInput" placeholder="Enter code" style="width: 160px;"></el-input>
<canvas ref="captchaCanvas" width="100" height="40" style="border:1px solid #ddd; cursor:pointer;" @click="generateCaptcha"></canvas>
</div>
</el-form-item>
</el-form>
<div slot="footer" class="dialog-footer">
<el-button @click="queryVisible = false">Cancel</el-button>
<el-button type="primary" @click="handleQuery">Enquiry</el-button>
</div>
</el-dialog>
<!-- 批核详情页 -->
<el-dialog :visible.sync="detailVisible" title="Application Progress Details" width="700px" append-to-body>
<div v-if="currentApplication">
<div class="form-section">
<h3 class="section-title">Application Basic Information</h3>
<table class="preview-table">
<tr><th>Application Number</th><td>{{ currentApplication.appNo }}</td></tr>
<tr><th>Apply for the product</th><td>{{ currentApplication.product }}</td></tr>
<tr><th>Application period</th><td>{{ currentApplication.submitTime }}</td></tr>
</table>
</div>
<div class="form-section">
<h3 class="section-title">Application Progress</h3>
<el-steps :active="currentApplication.stepIndex" finish-status="success" simple>
<el-step title="Application submission" :description="currentApplication.submitTime"></el-step>
<el-step title="Data Verification" description="Expected completion within two working days"></el-step>
<el-step title="Credit rating" description="Internal risk control approval"></el-step>
<el-step title="Approval outcome" :description="getFinalStatusDesc(currentApplication.status)"></el-step>
</el-steps>
</div>
<div class="form-section">
<h3 class="section-title">Approval status</h3>
<p><strong>Current status:</strong><span :style="{ color: getStatusColor(currentApplication.status) }">{{ getStatusText(currentApplication.status) }}</span></p>
<div v-if="currentApplication.status === 'pending_docs'" style="background:#fff8e1; padding:12px; border-left:4px solid #F59E0B; margin-top:10px;">
<strong>⚠️ Reminder for supplementary documents:</strong>{{ currentApplication.missingDocs }}
</div>
<div v-if="currentApplication.status === 'approved' && currentApplication.trackingNumber" class="form-section">
<p><strong>Parcel tracking number:</strong>{{ currentApplication.trackingNumber }}
<a :href="currentApplication.trackingUrl" target="_blank" style="color: var(--primary-color); margin-left:10px;">View logistics</a></p>
</div>
</div>
<div v-if="currentApplication.status === 'approved'" class="form-section">
<h3 class="section-title">Card Configuration</h3>
<table class="preview-table">
<tr><th>Credit limit</th><td>{{ currentApplication.creditLimit }}</td></tr>
<tr><th>Statement date / Repayment date</th><td>{{ currentApplication.billingDay }} / {{ currentApplication.repaymentDay }}</td></tr>
</table>
<div v-if="currentApplication.subCards.length > 0" style="margin-top:15px;">
<h4 style="font-weight:bold; margin-bottom:8px;">List of Supplementary Cards</h4>
<div v-for="(sub, idx) in currentApplication.subCards" :key="idx" style="padding:10px; background:#f9fafb; border-radius:6px; margin-bottom:8px;">
<span>Cardholder:{{ sub.name }}｜Status:{{ sub.status === 'approved' ? 'Approved' : 'Not approved' }}</span>
</div>
</div>
</div>
</div>
<div slot="footer" class="dialog-footer">
<el-button @click="detailVisible = false">Close</el-button>
</div>
</el-dialog>
</div>
<!-- 加载状态 -->
<div v-if="loading" class="loading-overlay">
<div class="loading-content">
<el-spinner :size="50"></el-spinner>
<p>Verifying token...</p>
</div>
</div>
</div>
</template>
<script>
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import {
Dialog, Form, FormItem, Input, Button, Select, Option, RadioGroup, Radio,
Upload, Steps, Step, Spinner, Loading, Message, DatePicker
} from 'element-ui';
// ✅ 导入 SignaturePad 组件
import SignaturePad from '@/views/SignaturePad.vue';
export default {
name: 'CreditCard',
components: {
[Dialog.name]: Dialog,
[Form.name]: Form,
[FormItem.name]: FormItem,
[Input.name]: Input,
[Button.name]: Button,
[Select.name]: Select,
[Option.name]: Option,
[RadioGroup.name]: RadioGroup,
[Radio.name]: Radio,
[Upload.name]: Upload,
[Steps.name]: Steps,
[Step.name]: Step,
[Spinner.name]: Spinner,
[DatePicker.name]: DatePicker,
// ✅ 注册 SignaturePad 组件
SignaturePad
},
data() {
return {
urlToken: '',
tokenValid: false,
loading: true,
adminCallbackUrl: '',
countryList: [
{ code: 'CN', name: 'China' },
{ code: 'US', name: 'United States' },
{ code: 'JP', name: 'Japan' },
{ code: 'GB', name: 'United Kingdom' },
{ code: 'CA', name: 'Canada' },
{ code: 'AU', name: 'Australia' },
{ code: 'DE', name: 'Germany' },
{ code: 'FR', name: 'France' },
{ code: 'SG', name: 'Singapore' },
{ code: 'HK', name: 'Hong Kong' },
{ code: 'TW', name: 'Taiwan' },
{ code: 'MO', name: 'Macau' },
{ code: 'MY', name: 'Malaysia' },
{ code: 'TH', name: 'Thailand' },
{ code: 'KR', name: 'South Korea' },
{ code: 'IN', name: 'India' },
{ code: 'ID', name: 'Indonesia' },
{ code: 'PH', name: 'Philippines' },
{ code: 'VN', name: 'Vietnam' },
{ code: 'RU', name: 'Russia' },
{ code: 'BR', name: 'Brazil' },
{ code: 'MX', name: 'Mexico' },
{ code: 'ZA', name: 'South Africa' },
{ code: 'AE', name: 'United Arab Emirates' },
{ code: 'SA', name: 'Saudi Arabia' },
{ code: 'IL', name: 'Israel' },
{ code: 'TR', name: 'Turkey' },
{ code: 'IT', name: 'Italy' },
{ code: 'ES', name: 'Spain' },
{ code: 'NL', name: 'Netherlands' },
{ code: 'SE', name: 'Sweden' },
{ code: 'NO', name: 'Norway' },
{ code: 'FI', name: 'Finland' },
{ code: 'DK', name: 'Denmark' },
{ code: 'CH', name: 'Switzerland' },
{ code: 'AT', name: 'Austria' },
{ code: 'BE', name: 'Belgium' },
{ code: 'PL', name: 'Poland' },
{ code: 'CZ', name: 'Czech Republic' },
{ code: 'HU', name: 'Hungary' },
{ code: 'GR', name: 'Greece' },
{ code: 'PT', name: 'Portugal' },
{ code: 'IE', name: 'Ireland' },
{ code: 'NZ', name: 'New Zealand' },
{ code: 'AR', name: 'Argentina' },
{ code: 'CL', name: 'Chile' },
{ code: 'CO', name: 'Colombia' },
{ code: 'PE', name: 'Peru' },
{ code: 'VE', name: 'Venezuela' }
],
industryOptions: [
{ label: 'Arms', value: 'Arms' },
{ label: 'Virtual Currency/Crypto Dealers', value: 'Virtual Currency/Crypto Dealers' },
{ label: 'Gaming/Casino', value: 'Gaming/Casino' },
{ label: 'Aerospace', value: 'Aerospace' },
{ label: 'Catering/Entertainment', value: 'Catering/Entertainment' },
{ label: 'Real Estate', value: 'Real Estate' },
{ label: 'Pawnbroking', value: 'Pawnbroking' },
{ label: 'Auction', value: 'Auction' },
{ label: 'Jewelry/Gemstone/Precious Metal Dealers', value: 'Jewelry/Gemstone/Precious Metal Dealers' },
{ label: 'Money Exchange', value: 'Money Exchange' },
{ label: 'Online Gaming', value: 'Online Gaming' },
{ label: 'Petroleum and Mining', value: 'Petroleum and Mining' },
{ label: 'Charities', value: 'Charities' },
{ label: 'Insurance', value: 'Insurance' },
{ label: 'Securities', value: 'Securities' },
{ label: 'Aircraft/Car/Yacht Dealers', value: 'Aircraft/Car/Yacht Dealers' },
{ label: 'Government', value: 'Government' },
{ label: 'Education', value: 'Education' },
{ label: 'Utilities', value: 'Utilities' },
{ label: 'Finance/Bank', value: 'Finance/Bank' },
{ label: 'Legal', value: 'Legal' },
{ label: 'Medical', value: 'Medical' },
{ label: 'IT/Internet', value: 'IT/Internet' },
{ label: 'Electronic', value: 'Electronic' },
{ label: 'Communication/Telecom', value: 'Communication/Telecom' },
{ label: 'Media/Visual/Advertising/Art', value: 'Media/Visual/Advertising/Art' },
{ label: 'Retail/E-commerce', value: 'Retail/E-commerce' },
{ label: 'Architecture/Engineering', value: 'Architecture/Engineering' },
{ label: 'Logistics/Shipping/Aviation', value: 'Logistics/Shipping/Aviation' },
{ label: 'Travel/Tourism/Hotels', value: 'Travel/Tourism/Hotels' },
{ label: 'Health/Beauty', value: 'Health/Beauty' },
{ label: 'Business Services', value: 'Business Services' },
{ label: 'Manufacturing/Garments and Textiles/Agriculture, Forestry and Fisheries', value: 'Manufacturing/Garments and Textiles/Agriculture, Forestry and Fisheries' },
{ label: 'Wholesale/Trading', value: 'Wholesale/Trading' },
{ label: 'Others', value: 'Others' }
],
positionOptions: [
{ label: 'Executive', value: 'Executive' },
{ label: 'Manager', value: 'Manager' },
{ label: 'Staff', value: 'Staff' }
],
purposeOptions: [
{ label: 'Shopping', value: 'Shopping' },
{ label: 'Payroll or commission', value: 'Payroll or commission' },
{ label: 'Personal purchase', value: 'Personal purchase' },
{ label: 'Daily consumption', value: 'Daily consumption' },
{ label: 'Personal loan payment', value: 'Personal loan payment' },
{ label: 'Payment for friends', value: 'Payment for friends' },
{ label: 'Others', value: 'Others' }
],
wealthOptions: [
{ label: 'Salary', value: 'Salary' },
{ label: 'Investment income', value: 'Investment income' },
{ label: 'Operating income', value: 'Operating income' },
{ label: 'Betting bonus', value: 'Betting bonus' },
{ label: 'Property asset sale', value: 'Property asset sale' },
{ label: 'Heritage', value: 'Heritage' },
{ label: 'Others', value: 'Others' }
],
termsVisible: false,
termsAgreed: false,
canAgree: false,
applicationFormVisible: false,
currentStep: 1,
previewVisible: false,
previewData: null,
formData: {
username: '',
trustAccount: '',
Name: '',
gender: '',
title: '',
nationality: '',
idNumber: '',
phone: '',
phoneCode: '+852',
email: '',
address: '',
englishName: '',
idType: '',
idIssueDate: '',
idExpiryDate: '',
idAddress: '',
dateOfBirth: '',
occupation: '',
jobTitle: '',
yearsOfService: '',
yearlyIncome: '',
companyName: '',
officeAddress: '',
officeTel: '',
officeTelCode: '+852',
accountPurpose: '',
sourceOfWealth: '',
sourceOfWealthOther: '',
// 主卡证件上传
idDocFrontFileList: [],
idDocFrontUrl: '',
idDocFrontUrl_raw: null,
idDocBackFileList: [],
idDocBackUrl: '',
idDocBackUrl_raw: null,
idDocInfoFileList: [],
idDocInfoUrl: '',
idDocInfoUrl_raw: null,
// 主卡
cardName1: '',
cardType1: '',
showNameOnCard1: true,
showLogoOnCard1: true,
// 主卡签名
signatureData1: '',
isSigned1: false,
// 附属卡 1
cardName2Chinese: '',
cardName2: '',
gender2: '',
nationality2: '',
idNumber2: '',
idType2: '',
dateOfBirth2: '',
idIssueDate2: '',
idExpiryDate2: '',
idAddress2: '',
phone2: '',
phoneCode2: '+852',
email2: '',
address2: '',
occupation2: '',
jobTitle2: '',
yearsOfService2: '',
yearlyIncome2: '',
companyName2: '',
officeAddress2: '',
officeTel2: '',
officeTelCode2: '+852',
accountPurpose2: '',
sourceOfWealth2: '',
sourceOfWealthOther2: '',
cardType2: '',
showNameOnCard2: true,
showLogoOnCard2: true,
creditLimit2: '',
idDocFrontFileList2: [],
idDocFrontUrl2: '',
idDocFrontUrl2_raw: null,
idDocBackFileList2: [],
idDocBackUrl2: '',
idDocBackUrl2_raw: null,
idDocInfoFileList2: [],
idDocInfoUrl2: '',
idDocInfoUrl2_raw: null,
// 附属卡 1 签名
signatureData2: '',
isSigned2: false,
// 附属卡 2
cardName3Chinese: '',
cardName3: '',
gender3: '',
nationality3: '',
idNumber3: '',
idType3: '',
dateOfBirth3: '',
idIssueDate3: '',
idExpiryDate3: '',
idAddress3: '',
phone3: '',
phoneCode3: '+852',
email3: '',
address3: '',
occupation3: '',
jobTitle3: '',
yearsOfService3: '',
yearlyIncome3: '',
companyName3: '',
officeAddress3: '',
officeTel3: '',
officeTelCode3: '+852',
accountPurpose3: '',
sourceOfWealth3: '',
sourceOfWealthOther3: '',
cardType3: '',
showNameOnCard3: true,
showLogoOnCard3: true,
creditLimit3: '',
idDocFrontFileList3: [],
idDocFrontUrl3: '',
idDocFrontUrl3_raw: null,
idDocBackFileList3: [],
idDocBackUrl3: '',
idDocBackUrl3_raw: null,
idDocInfoFileList3: [],
idDocInfoUrl3: '',
idDocInfoUrl3_raw: null,
// 附属卡 2 签名
signatureData3: '',
isSigned3: false,
showCard2: false,
showCard3: false,
allowedCards: []
},
cardTypeLabels: { gold: 'Gold Card', platinum: 'Platinum Card', black: 'Black Card' },
currentUserInfo: null,
queryVisible: false,
detailVisible: false,
queryForm: { type: 'trust', value: '', captchaInput: '' },
captchaCode: '',
currentApplication: null,
approvalDatabase: [
{
appNo: 'APP20260115A',
trustAccount: 'C123456',
idNumber: 'A123456(7)',
product: 'GFOA Exclusive Trust Gold Card',
submitTime: '2026-01-10 14:30',
status: 'reviewing',
stepIndex: 1,
missingDocs: '',
trackingNumber: '',
trackingUrl: '',
creditLimit: 'HKD 200,000',
billingDay: '15th of each month',
repaymentDay: '30th of each month',
subCards: [{ name: 'Zhang Xiaowei', status: 'approved' }]
},
{
appNo: 'APP20260114B',
trustAccount: 'C789012',
idNumber: 'P78901234',
product: 'GFOA Black Card',
submitTime: '2026-01-09 10:15',
status: 'pending_docs',
stepIndex: 1,
missingDocs: 'Missing supplementary card ID front/back and proof of address',
trackingNumber: '',
trackingUrl: '',
creditLimit: '',
billingDay: '',
repaymentDay: '',
subCards: []
}
]
// ✅ 已移除原生 Canvas 签名相关状态: drawing, currentSigIndex, lastX, lastY
};
},
computed: {
availableCardTypes() {
const allCardOptions = [
{ value: 'gold', label: 'Gold Card', id: 1, visible: false },
{ value: 'platinum', label: 'Platinum Card', id: 2, visible: false },
{ value: 'black', label: 'Black Card', id: 3, visible: false }
];
const allowed = this.formData.allowedCards || [];
allCardOptions.forEach(option => {
option.visible = allowed.includes(option.id);
});
return allCardOptions;
}
},
methods: {
// ✅ 新增：处理签名组件的 input 事件
handleSignatureUpdate(index, value) {
this.formData[`signatureData${index}`] = value;
// 简单校验：非空且长度大于100（base64头约50字符+实际笔迹）
this.formData[`isSigned${index}`] = !!value && value.length > 100;
},
// ✅ 新增：清除签名（调用子组件方法）
clearSignature(index) {
const refName = `sigPad${index}`;
if (this.$refs[refName] && this.$refs[refName][0]) {
this.$refs[refName][0].clear();
}
},
checkUrlToken() {
const query = this.$route?.query || {};
const testMode = query.test;
const token = query.token;
const callback = query.callback;
this.adminCallbackUrl = callback || '';
if (testMode === 'uCFYP7pxXzXDSd5ubDKakwxK' && !token) {
console.log('🧪 Test mode enabled');
this.urlToken = 'mock_token_for_testing';
this.verifyToken(true);
return;
}
if (token) {
console.log('🔑 Token found:', token);
this.urlToken = token;
this.verifyToken(false);
return;
}
console.warn('⚠️ No token provided');
this.tokenValid = false;
this.loading = false;
this.$message.error('Access denied: Missing token parameter');
},
async verifyToken(isMock = false) {
try {
let response;
if (isMock) {
response = {
data: {
status: 1,
message: 'Token verified (mock)',
data: {
username: 'C123456',
name: '张三',
gender: 'male',
title: 'Mr.',
phone: '13800138000',
address: '123 Test Street, Hong Kong',
nationality: 'China',
idNumber: 'A123456(7)',
email: 'test@example.com',
allowedCards: [1, 2, 3]
}
}
};
await new Promise(resolve => setTimeout(resolve, 500));
} else {
response = await axios.post(
'http://172.30.20.33/new_hkt/api/misc/verify_token',
{ token: this.urlToken },
{
headers: { 'Content-Type': 'application/json' },
timeout: 10000
}
);
}
if (response.data && response.data.status === 1) {
this.tokenValid = true;
const userData = response.data.data;
this.formData.username = userData.username || '';
this.formData.trustAccount = userData.username || '';
this.formData.Name = userData.name || '';
this.formData.gender = userData.gender || '';
this.formData.title = userData.title || '';
this.formData.phone = userData.phone || '';
this.formData.address = userData.address || '';
this.formData.nationality = userData.nationality || '';
this.formData.idNumber = userData.idNumber || '';
this.formData.email = userData.email || '';
this.formData.allowedCards = Array.isArray(userData.allowedCards) ? userData.allowedCards : [];
this.currentUserInfo = userData;
this.$message.success('Token verified successfully!' + (isMock ? ' (Test Mode)' : ''));
this.cleanUrlToken();
} else {
this.tokenValid = false;
this.$message.error('Token verification failed: ' + (response.data.message || 'Invalid token'));
}
} catch (error) {
console.error('Token verification error:', error);
this.tokenValid = false;
if (error.response) {
this.$message.error(`API Error ${error.response.status}: ${error.response.data?.message || 'Verification failed'}`);
} else if (error.request) {
this.$message.error('Network error: Unable to connect to verification server');
} else {
this.$message.error('Token verification error. Please contact administrator.');
}
} finally {
this.loading = false;
}
},
cleanUrlToken() {
const cleanPath = window.location.pathname + window.location.hash.split('?')[0];
window.history.replaceState({}, document.title, cleanPath);
console.log('🧹 URL cleaned, token hidden from address bar');
if (this.$router?.currentRoute?.query?.token) {
this.$router.replace({
path: this.$route.path,
query: {
...this.$route.query,
token: undefined,
test: undefined,
callback: undefined
}
}).catch(() => {});
}
},
startApplication() {
if (!this.tokenValid) {
this.$message.error('Please verify token first');
return;
}
this.openTermsDialog();
},
openTermsDialog() {
this.termsVisible = true;
this.termsAgreed = false;
this.canAgree = false;
this.$nextTick(() => {
if (this.$refs.termsContentRef) this.$refs.termsContentRef.scrollTop = 0;
});
if (this.currentUserInfo) {
this.loadCustomerData();
}
},
closeTermsDialog() {
this.termsVisible = false;
this.termsAgreed = false;
this.canAgree = false;
},
handleTermsScroll(event) {
const el = event.target;
this.canAgree = (el.scrollHeight - el.scrollTop <= el.clientHeight + 5);
},
acceptTerms() {
if (this.termsAgreed) {
this.termsVisible = false;
this.applicationFormVisible = true;
this.currentStep = 1;
}
},
loadCustomerData() {
if (this.currentUserInfo) {
const info = this.currentUserInfo;
this.formData.username = info.username || '';
this.formData.trustAccount = info.username || '';
this.formData.Name = info.name || '';
this.formData.title = info.title || '';
this.formData.gender = info.gender || '';
this.formData.phone = info.phone || '';
this.formData.address = info.address || '';
this.formData.nationality = info.nationality || '';
this.formData.idNumber = info.idNumber || '';
this.formData.email = info.email || '';
this.formData.allowedCards = Array.isArray(info.allowedCards) ? info.allowedCards : [];
}
},
handleIdTypeChange() {
this.formData.idDocFrontFileList = [];
this.formData.idDocBackFileList = [];
this.formData.idDocInfoFileList = [];
this.formData.idDocFrontUrl = '';
this.formData.idDocBackUrl = '';
this.formData.idDocInfoUrl = '';
this.formData.idDocFrontUrl_raw = null;
this.formData.idDocBackUrl_raw = null;
this.formData.idDocInfoUrl_raw = null;
if (this.formData.idType === 'HKID' || this.formData.idType === 'Other') {
this.formData.idExpiryDate = '';
}
},
handleIdTypeChange2() {
this.formData.idDocFrontFileList2 = [];
this.formData.idDocBackFileList2 = [];
this.formData.idDocInfoFileList2 = [];
this.formData.idDocFrontUrl2 = '';
this.formData.idDocBackUrl2 = '';
this.formData.idDocInfoUrl2 = '';
this.formData.idDocFrontUrl2_raw = null;
this.formData.idDocBackUrl2_raw = null;
this.formData.idDocInfoUrl2_raw = null;
},
handleIdTypeChange3() {
this.formData.idDocFrontFileList3 = [];
this.formData.idDocBackFileList3 = [];
this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3 = '';
this.formData.idDocBackUrl3 = '';
this.formData.idDocInfoUrl3 = '';
this.formData.idDocFrontUrl3_raw = null;
this.formData.idDocBackUrl3_raw = null;
this.formData.idDocInfoUrl3_raw = null;
},
handlePurposeChange() {
if (this.formData.accountPurpose !== 'Others') {}
},
handlePurposeChange2() {
if (this.formData.accountPurpose2 !== 'Others') {}
},
handlePurposeChange3() {
if (this.formData.accountPurpose3 !== 'Others') {}
},
handleWealthChange() {
if (this.formData.sourceOfWealth !== 'Others') {
this.formData.sourceOfWealthOther = '';
}
},
handleWealthChange2() {
if (this.formData.sourceOfWealth2 !== 'Others') {
this.formData.sourceOfWealthOther2 = '';
}
},
handleWealthChange3() {
if (this.formData.sourceOfWealth3 !== 'Others') {
this.formData.sourceOfWealthOther3 = '';
}
},
handleIdUpload(file, targetUrlField, targetFileList) {
console.log('📁 File selected:', file.name, file.size, file.raw?.type);
const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
const fileType = file.raw?.type || file.type;
const isAllowedType = allowedTypes.includes(fileType);
if (!isAllowedType) {
this.$message.error('Supports JPG, PNG, or PDF formats only');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const limitSize = 5 * 1024 * 1024;
const fileSize = file.size || file.raw?.size || 0;
if (fileSize > limitSize) {
this.$message.error('File size must not exceed 5MB!');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const fileObj = {
name: file.name || file.raw?.name || 'uploaded_file',
size: fileSize,
type: fileType,
status: 'ready',
uid: Date.now() + Math.random()
};
this.$set(this.formData, targetUrlField + '_raw', file.raw || file);
this.$set(this.formData, targetFileList, [fileObj]);
this.$message.success('File selected successfully. Will upload on final submission.');
this.$forceUpdate();
return false;
},
handlePhoneInput(cardIndex, value) {
const cleanValue = value.replace(/\D/g, '');
if (cardIndex === 2) {
this.$set(this.formData, 'phone2', cleanValue);
} else if (cardIndex === 3) {
this.$set(this.formData, 'phone3', cleanValue);
}
},
openQueryDialog() {
this.queryVisible = true;
this.queryForm = { type: 'trust', value: '', captchaInput: '' };
this.$nextTick(() => {
this.generateCaptcha();
});
},
generateCaptcha() {
const code = Math.floor(1000 + Math.random() * 9000).toString();
this.captchaCode = code;
const canvas = this.$refs.captchaCanvas;
if (!canvas) return;
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, canvas.width, canvas.height);
ctx.font = '24px Arial';
ctx.fillStyle = '#333';
ctx.fillText(code, 15, 30);
for (let i = 0; i < 5; i++) {
ctx.strokeStyle = `rgb(${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)},${Math.floor(Math.random()*200)})`;
ctx.beginPath();
ctx.moveTo(Math.random()*100, Math.random()*40);
ctx.lineTo(Math.random()*100, Math.random()*40);
ctx.stroke();
}
},
handleQuery() {
if (!this.queryForm.value.trim()) {
this.$message.warning('Please enter your search criteria');
return;
}
if (!this.queryForm.captchaInput.trim()) {
this.$message.warning('Please enter the CAPTCHA');
return;
}
if (this.queryForm.captchaInput !== this.captchaCode) {
this.$message.error('Graphical CAPTCHA error');
this.generateCaptcha();
return;
}
let record = null;
if (this.queryForm.type === 'trust') {
record = this.approvalDatabase.find(item => item.trustAccount === this.queryForm.value);
} else {
record = this.approvalDatabase.find(item => item.idNumber === this.queryForm.value);
}
if (record) {
this.currentApplication = { ...record };
this.queryVisible = false;
this.detailVisible = true;
} else {
this.$message.error('No relevant application records were found.');
}
},
getStatusText(status) {
const map = { submitted: 'Submitted', reviewing: 'Under review', pending_docs: 'To be supplemented', approved: 'Approved', rejected: 'Not approved' };
return map[status] || 'Unknown';
},
getStatusColor(status) {
const map = { submitted: '#60a5fa', reviewing: '#3b82f6', pending_docs: '#f59e0b', approved: '#10b981', rejected: '#ef4444' };
return map[status] || '#64748b';
},
getFinalStatusDesc(status) {
if (status === 'approved') return 'Success';
if (status === 'rejected') return 'Refusal';
if (status === 'pending_docs') return 'Additional documentation is required.';
return 'Pending';
},
sanitizeEnglishName(name) {
if (!name) return '';
return name.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');
},
handleCardName1Input(value) { this.formData.cardName1 = this.sanitizeEnglishName(value); },
handleCardName2Input(value) { this.formData.cardName2 = this.sanitizeEnglishName(value); },
handleCardName3Input(value) { this.formData.cardName3 = this.sanitizeEnglishName(value); },
nextStep() {
if (this.currentStep === 1) {
if (!this.formData.englishName || !this.formData.idType || !this.formData.dateOfBirth || !this.formData.occupation) {
this.$message.warning('Please complete all required fields in Step 1');
return;
}
if (this.formData.idType === 'MainlandID') {
const hasFront = this.formData.idDocFrontUrl_raw || (this.formData.idDocFrontFileList?.length > 0);
const hasBack = this.formData.idDocBackUrl_raw || (this.formData.idDocBackFileList?.length > 0);
if (!hasFront || !hasBack) {
this.$message.warning('Please upload both front and back of your ID');
return;
}
} else {
const hasInfo = this.formData.idDocInfoUrl_raw || (this.formData.idDocInfoFileList?.length > 0);
if (!hasInfo) {
this.$message.warning('Please upload your ID/Passport information page');
return;
}
}
}
if (this.currentStep < 2) this.currentStep++;
},
prevStep() { if (this.currentStep > 1) this.currentStep--; },
toggleCard2() {
this.$set(this.formData, 'showCard2', !this.formData.showCard2);
if (!this.formData.showCard2) {
this.formData.cardName2Chinese = '';
this.formData.cardName2 = ''; this.formData.gender2 = ''; this.formData.nationality2 = '';
this.formData.idNumber2 = ''; this.formData.idType2 = ''; this.formData.dateOfBirth2 = '';
this.formData.idIssueDate2 = ''; this.formData.idExpiryDate2 = ''; this.formData.idAddress2 = '';
this.formData.phone2 = ''; this.formData.email2 = ''; this.formData.address2 = '';
this.formData.occupation2 = ''; this.formData.jobTitle2 = '';
this.formData.yearsOfService2 = ''; this.formData.yearlyIncome2 = '';
this.formData.companyName2 = ''; this.formData.officeAddress2 = '';
this.formData.officeTel2 = ''; this.formData.officeTelCode2 = '+852';
this.formData.accountPurpose2 = ''; this.formData.sourceOfWealth2 = '';
this.formData.sourceOfWealthOther2 = '';
this.formData.cardType2 = '';
this.formData.showNameOnCard2 = true; this.formData.showLogoOnCard2 = true;
this.formData.creditLimit2 = '';
this.formData.idDocFrontFileList2 = []; this.formData.idDocBackFileList2 = []; this.formData.idDocInfoFileList2 = [];
this.formData.idDocFrontUrl2_raw = null; this.formData.idDocBackUrl2_raw = null; this.formData.idDocInfoUrl2_raw = null;
this.formData.signatureData2 = ''; this.formData.isSigned2 = false;
this.$set(this.formData, 'showCard3', false);
this.formData.cardName3Chinese = '';
this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
this.formData.idNumber3 = ''; this.formData.idType3 = ''; this.formData.dateOfBirth3 = '';
this.formData.idIssueDate3 = ''; this.formData.idExpiryDate3 = ''; this.formData.idAddress3 = '';
this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.address3 = '';
this.formData.occupation3 = ''; this.formData.jobTitle3 = '';
this.formData.yearsOfService3 = ''; this.formData.yearlyIncome3 = '';
this.formData.companyName3 = ''; this.formData.officeAddress3 = '';
this.formData.officeTel3 = ''; this.formData.officeTelCode3 = '+852';
this.formData.accountPurpose3 = ''; this.formData.sourceOfWealth3 = '';
this.formData.sourceOfWealthOther3 = '';
this.formData.cardType3 = '';
this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
this.formData.creditLimit3 = '';
this.formData.idDocFrontFileList3 = []; this.formData.idDocBackFileList3 = []; this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3_raw = null; this.formData.idDocBackUrl3_raw = null; this.formData.idDocInfoUrl3_raw = null;
this.formData.signatureData3 = ''; this.formData.isSigned3 = false;
}
},
toggleCard3() {
this.$set(this.formData, 'showCard3', !this.formData.showCard3);
if (!this.formData.showCard3) {
this.formData.cardName3Chinese = '';
this.formData.cardName3 = ''; this.formData.gender3 = ''; this.formData.nationality3 = '';
this.formData.idNumber3 = ''; this.formData.idType3 = ''; this.formData.dateOfBirth3 = '';
this.formData.idIssueDate3 = ''; this.formData.idExpiryDate3 = ''; this.formData.idAddress3 = '';
this.formData.phone3 = ''; this.formData.email3 = ''; this.formData.address3 = '';
this.formData.occupation3 = ''; this.formData.jobTitle3 = '';
this.formData.yearsOfService3 = ''; this.formData.yearlyIncome3 = '';
this.formData.companyName3 = ''; this.formData.officeAddress3 = '';
this.formData.officeTel3 = ''; this.formData.officeTelCode3 = '+852';
this.formData.accountPurpose3 = ''; this.formData.sourceOfWealth3 = '';
this.formData.sourceOfWealthOther3 = '';
this.formData.cardType3 = '';
this.formData.showNameOnCard3 = true; this.formData.showLogoOnCard3 = true;
this.formData.creditLimit3 = '';
this.formData.idDocFrontFileList3 = []; this.formData.idDocBackFileList3 = []; this.formData.idDocInfoFileList3 = [];
this.formData.idDocFrontUrl3_raw = null; this.formData.idDocBackUrl3_raw = null; this.formData.idDocInfoUrl3_raw = null;
this.formData.signatureData3 = ''; this.formData.isSigned3 = false;
}
},
getCharCountClass(len) {
if (len > 20) return 'error';
if (len > 15) return 'warning';
return '';
},
getCardImage(type, showLogo = true) {
if (type === 'gold') {
return showLogo
? require('@/assets/gold-card-with-logo.png')
: require('@/assets/gold-card-no-logo.png');
}
if (type === 'platinum') {
return showLogo
? require('@/assets/platinum-card-with-logo.png')
: require('@/assets/platinum-card-no-logo.png');
}
if (type === 'black') {
return showLogo
? require('@/assets/black-card-with-logo.png')
: require('@/assets/black-card-no-logo.png');
}
return require('@/assets/gold-card.png');
},
boolToText(val) { return val ? 'Yes' : 'No'; },
submitApplication() {
if (!this.formData.cardName1 || !this.formData.cardType1) {
this.$message.warning('Please enter at least the primary cardholder name and select the card type.');
return;
}
// 验证签名
if (!this.formData.isSigned1) {
this.$message.warning('Primary cardholder signature is required');
return;
}
if (this.formData.showCard2 && this.formData.cardName2 && !this.formData.isSigned2) {
this.$message.warning('Supplementary card 1 holder signature is required');
return;
}
if (this.formData.showCard3 && this.formData.cardName3 && !this.formData.isSigned3) {
this.$message.warning('Supplementary card 2 holder signature is required');
return;
}
// 验证附属卡 1
if (this.formData.showCard2 && this.formData.cardName2) {
if (!this.formData.cardName2Chinese) {
this.$message.warning('Please enter Chinese name for Supplementary Card 1');
return;
}
if (!this.formData.gender2 || !this.formData.nationality2 || !this.formData.dateOfBirth2 || !this.formData.idType2 || !this.formData.idNumber2) {
this.$message.warning('Please complete all required fields for Supplementary Card 1');
return;
}
if (this.formData.idType2 === 'MainlandID') {
const hasFront2 = this.formData.idDocFrontUrl2_raw || (this.formData.idDocFrontFileList2?.length > 0);
const hasBack2 = this.formData.idDocBackUrl2_raw || (this.formData.idDocBackFileList2?.length > 0);
if (!hasFront2 || !hasBack2) {
this.$message.warning('Please upload ID documents for Supplementary Card 1');
return;
}
} else {
const hasInfo2 = this.formData.idDocInfoUrl2_raw || (this.formData.idDocInfoFileList2?.length > 0);
if (!hasInfo2) {
this.$message.warning('Please upload ID document for Supplementary Card 1');
return;
}
}
if (!this.formData.creditLimit2) {
this.$message.warning('Please set credit limit for Supplementary Card 1');
return;
}
}
// 验证附属卡 2
if (this.formData.showCard3 && this.formData.cardName3) {
if (!this.formData.cardName3Chinese) {
this.$message.warning('Please enter Chinese name for Supplementary Card 2');
return;
}
if (!this.formData.gender3 || !this.formData.nationality3 || !this.formData.dateOfBirth3 || !this.formData.idType3 || !this.formData.idNumber3) {
this.$message.warning('Please complete all required fields for Supplementary Card 2');
return;
}
if (this.formData.idType3 === 'MainlandID') {
const hasFront3 = this.formData.idDocFrontUrl3_raw || (this.formData.idDocFrontFileList3?.length > 0);
const hasBack3 = this.formData.idDocBackUrl3_raw || (this.formData.idDocBackFileList3?.length > 0);
if (!hasFront3 || !hasBack3) {
this.$message.warning('Please upload ID documents for Supplementary Card 2');
return;
}
} else {
const hasInfo3 = this.formData.idDocInfoUrl3_raw || (this.formData.idDocInfoFileList3?.length > 0);
if (!hasInfo3) {
this.$message.warning('Please upload ID document for Supplementary Card 2');
return;
}
}
if (!this.formData.creditLimit3) {
this.$message.warning('Please set credit limit for Supplementary Card 2');
return;
}
}
this.previewData = { ...this.formData };
this.previewVisible = true;
},
async confirmAndSubmit() {
const loading = this.$loading({
lock: true,
text: 'Processing: Uploading attachments & submitting form...',
background: 'rgba(0,0,0,0.7)'
});
try {
const uploadPromises = [];
const uploadResults = {};
// ========== 主申请人证件上传 ==========
if (this.formData.idDocFrontUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl = res.data.url;
uploadResults.idDocFrontUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Front Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl = res.data.url;
uploadResults.idDocBackUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Back Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Main Applicant ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl = res.data.url;
uploadResults.idDocInfoUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Main Applicant ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Main Applicant ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Main Applicant ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Main Applicant ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Main Applicant ID Info Page Upload Failed: ' + err.message);
}
})
);
}
// ========== 附属卡 1 证件上传 ==========
if (this.formData.idDocFrontUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl2 = res.data.url;
uploadResults.idDocFrontUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Front Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl2 = res.data.url;
uploadResults.idDocBackUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Back Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl2_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl2_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 1 ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl2 = res.data.url;
uploadResults.idDocInfoUrl2 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 1 ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 1 ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 1 ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 1 ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 1 ID Info Page Upload Failed: ' + err.message);
}
})
);
}
// ========== 附属卡 2 证件上传 ==========
if (this.formData.idDocFrontUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl3 = res.data.url;
uploadResults.idDocFrontUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Front Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl3 = res.data.url;
uploadResults.idDocBackUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Back Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl3_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl3_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ Supp Card 2 ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl3 = res.data.url;
uploadResults.idDocInfoUrl3 = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('Supp Card 2 ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ Supp Card 2 ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('Supp Card 2 ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('Supp Card 2 ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('Supp Card 2 ID Info Page Upload Failed: ' + err.message);
}
})
);
}
if (uploadPromises.length > 0) {
console.log('📤 Starting upload of', uploadPromises.length, 'files...');
await Promise.all(uploadPromises);
console.log('✅ All files uploaded', uploadResults);
}
const postData = {
trustAccount: this.formData.username,
Name: this.formData.Name,
englishName: this.formData.englishName,
gender: this.formData.gender,
nationality: this.formData.nationality,
idNumber: this.formData.idNumber,
idType: this.formData.idType,
idIssueDate: this.formData.idIssueDate,
idExpiryDate: this.formData.idExpiryDate,
idAddress: this.formData.idAddress,
dateOfBirth: this.formData.dateOfBirth,
occupation: this.formData.occupation,
jobTitle: this.formData.jobTitle,
yearsOfService: this.formData.yearsOfService,
yearlyIncome: this.formData.yearlyIncome,
companyName: this.formData.companyName,
officeAddress: this.formData.officeAddress,
officeTelCode: this.formData.officeTelCode,
officeTel: this.formData.officeTel,
accountPurpose: this.formData.accountPurpose,
sourceOfWealth: this.formData.sourceOfWealth,
sourceOfWealthOther: this.formData.sourceOfWealthOther,
phoneCode: this.formData.phoneCode,
phone: this.formData.phone,
email: this.formData.email,
address: this.formData.address,
idDocFrontUrl: this.formData.idDocFrontUrl,
idDocBackUrl: this.formData.idDocBackUrl,
idDocInfoUrl: this.formData.idDocInfoUrl,
signature1: this.formData.signatureData1,
cardType1: this.formData.cardType1,
showNameOnCard1: this.formData.showNameOnCard1,
showLogoOnCard1: this.formData.showLogoOnCard1,
cardName2Chinese: this.formData.cardName2Chinese,
cardName2: this.formData.cardName2,
gender2: this.formData.gender2,
nationality2: this.formData.nationality2,
idNumber2: this.formData.idNumber2,
idType2: this.formData.idType2,
dateOfBirth2: this.formData.dateOfBirth2,
idIssueDate2: this.formData.idIssueDate2,
idExpiryDate2: this.formData.idExpiryDate2,
idAddress2: this.formData.idAddress2,
phoneCode2: this.formData.phoneCode2,
phone2: this.formData.phone2,
email2: this.formData.email2,
address2: this.formData.address2,
occupation2: this.formData.occupation2,
jobTitle2: this.formData.jobTitle2,
yearsOfService2: this.formData.yearsOfService2,
yearlyIncome2: this.formData.yearlyIncome2,
companyName2: this.formData.companyName2,
officeAddress2: this.formData.officeAddress2,
officeTelCode2: this.formData.officeTelCode2,
officeTel2: this.formData.officeTel2,
accountPurpose2: this.formData.accountPurpose2,
sourceOfWealth2: this.formData.sourceOfWealth2,
sourceOfWealthOther2: this.formData.sourceOfWealthOther2,
cardType2: this.formData.cardType2,
showNameOnCard2: this.formData.showNameOnCard2,
showLogoOnCard2: this.formData.showLogoOnCard2,
creditLimit2: this.formData.creditLimit2,
idDocFrontUrl2: this.formData.idDocFrontUrl2,
idDocBackUrl2: this.formData.idDocBackUrl2,
idDocInfoUrl2: this.formData.idDocInfoUrl2,
signature2: this.formData.signatureData2,
cardName3Chinese: this.formData.cardName3Chinese,
cardName3: this.formData.cardName3,
gender3: this.formData.gender3,
nationality3: this.formData.nationality3,
idNumber3: this.formData.idNumber3,
idType3: this.formData.idType3,
dateOfBirth3: this.formData.dateOfBirth3,
idIssueDate3: this.formData.idIssueDate3,
idExpiryDate3: this.formData.idExpiryDate3,
idAddress3: this.formData.idAddress3,
phoneCode3: this.formData.phoneCode3,
phone3: this.formData.phone3,
email3: this.formData.email3,
address3: this.formData.address3,
occupation3: this.formData.occupation3,
jobTitle3: this.formData.jobTitle3,
yearsOfService3: this.formData.yearsOfService3,
yearlyIncome3: this.formData.yearlyIncome3,
companyName3: this.formData.companyName3,
officeAddress3: this.formData.officeAddress3,
officeTelCode3: this.formData.officeTelCode3,
officeTel3: this.formData.officeTel3,
accountPurpose3: this.formData.accountPurpose3,
sourceOfWealth3: this.formData.sourceOfWealth3,
sourceOfWealthOther3: this.formData.sourceOfWealthOther3,
cardType3: this.formData.cardType3,
showNameOnCard3: this.formData.showNameOnCard3,
showLogoOnCard3: this.formData.showLogoOnCard3,
creditLimit3: this.formData.creditLimit3,
idDocFrontUrl3: this.formData.idDocFrontUrl3,
idDocBackUrl3: this.formData.idDocBackUrl3,
idDocInfoUrl3: this.formData.idDocInfoUrl3,
signature3: this.formData.signatureData3,
token: this.urlToken || '',
applicationSource: 'admin_token'
};
console.log('📤 Submitting form data...', postData);
const res = await axios.post('https://htkcmvisa.giize.com/submit_credit_card.php', postData, {
timeout: 30000
});
if (res.data && res.data.status === 1) {
this.$message.success('Your credit card application has been successfully submitted!');
this.applicationFormVisible = false;
if (this.adminCallbackUrl && res.data.applicationId) {
this.notifyAdminCallback(res.data.applicationId);
}
} else {
this.$message.error('Submission failed: ' + (res.data.message || 'Unknown error'));
}
} catch (error) {
console.error('❌ Final Submission Error:', error);
const userMsg = error.message.includes('Upload Failed')
? error.message
: 'System error: ' + (error.message || 'Unknown');
this.$message.error(userMsg);
} finally {
loading.close();
}
},
async notifyAdminCallback(applicationId) {
try {
await axios.post(this.adminCallbackUrl, {
token: this.urlToken,
applicationId: applicationId,
status: 'submitted',
submitTime: new Date().toISOString()
});
console.log('Admin callback successful');
} catch (error) {
console.error('Admin callback failed:', error);
}
},
goHome() {
window.history.pushState({}, document.title, window.location.pathname);
this.urlToken = '';
this.tokenValid = false;
}
},
mounted() {
this.generateCaptcha();
this.checkUrlToken();
}
};
</script>
<style>
:root {
--bg-light: #f8f9fc;
--primary-color: #1E3A8A;
--accent-color: #F59E0B;
--border-color: #e2e8f0;
--text-primary: #1E293B;
--text-secondary: #64748B;
--text-error: #EF4444;
--bg-white: #fff;
--bg-gray: #f8f9fa;
}
body, html { margin: 0; padding: 0; height: 100%; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; background-color: var(--bg-light); overflow: hidden; }
.app-wrapper { display: flex; height: 100vh; }
.access-denied { display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f8f9fc; width: 100%; }
.denied-content { text-align: center; padding: 40px; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.denied-content h1 { color: #EF4444; margin-bottom: 20px; }
.denied-content p { color: #64748B; margin-bottom: 30px; }
.loading-overlay { display: flex; justify-content: center; align-items: center; height: 100vh; background: #f8f9fc; width: 100%; }
.loading-content { text-align: center; }
.loading-content p { margin-top: 15px; color: var(--text-secondary); }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }
.apply-section { background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); margin-top: 20px; }
.apply-item { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; border-bottom: 1px solid #eee; }
.apply-item:last-child { border-bottom: none; }
.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: bold; font-size: 16px; color: #333; margin-bottom: 5px; }
.apply-desc { font-size: 14px; color: #666; }
.apply-btn { min-width: 120px; padding: 10px 20px; border-radius: 8px; font-weight: 500; cursor: pointer; text-align: center; transition: all 0.3s ease; }
.apply-btn-primary { background-color: var(--primary-color); color: white; border: 1px solid var(--primary-color); }
.apply-btn-primary:hover { background-color: #3B82F6; border-color: #3B82F6; }
.apply-btn-secondary { background-color: white; color: var(--primary-color); border: 1px solid var(--primary-color); }
.apply-btn-secondary:hover { background-color: #eff6ff; }
.terms-dialog .el-dialog__body { padding: 0; overflow: hidden; }
.terms-header { padding: 20px 30px; background: var(--bg-gray); border-bottom: 1px solid var(--border-color); font-weight: bold; text-align: center; color: var(--primary-color); }
.terms-content { padding: 30px; max-height: 50vh; overflow-y: auto; line-height: 1.8; font-size: 14px; color: var(--text-primary); text-align: left; }
.terms-footer { padding: 20px 30px; background: var(--bg-gray); border-top: 1px solid var(--border-color); display: flex; align-items: center; justify-content: space-between; }
.terms-checkbox { display: flex; align-items: flex-start; gap: 8px; }
.terms-checkbox input[type="checkbox"] { margin-top: 3px; }
.terms-checkbox-label { font-size: 11px; color: var(--text-secondary); }
.terms-checkbox-label span { color: var(--text-error); }
.terms-actions { display: flex; gap: 10px; }
.terms-cancel { flex: 1; background: white; border: 1px solid #ddd; color: var(--text-secondary); }
.terms-accept { flex: 1; background: var(--primary-color); border: none; color: white; }
.terms-accept:disabled { background: #93c5fd; cursor: not-allowed; }
.application-form-dialog .el-dialog { width: 1400px !important; max-width: 95vw; }
.application-form-dialog .el-dialog__body { padding: 30px; background: var(--bg-white); max-height: 80vh; overflow-y: auto; }
.form-section { margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid var(--border-color); }
.section-title { font-size: 18px; font-weight: bold; color: var(--primary-color); margin-bottom: 20px; display: flex; align-items: center; }
.section-title::before { content: ''; display: inline-block; width: 4px; height: 20px; background: var(--accent-color); margin-right: 10px; border-radius: 2px; }
.form-group-title { font-size: 16px; font-weight: 600; color: var(--text-primary); margin-top: 10px; border-left: 3px solid var(--primary-color); padding-left: 10px; }
.part-a-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
.form-group { display: flex; flex-direction: column; }
.form-label { font-size: 14px; font-weight: 500; color: var(--text-primary); margin-bottom: 6px; }
.form-input { padding: 10px 12px; border: 1px solid var(--border-color); border-radius: 4px; font-size: 14px; color: var(--text-primary); transition: border-color 0.2s; }
.form-input:focus { outline: none; border-color: var(--primary-color); box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.1); }
.large-input { width: 100%; min-height: 40px; padding: 10px 12px; }
.readonly-input { background-color: #f5f7fa !important; color: #6c757d; cursor: not-allowed; border-color: #e2e8f0; }
.required-input { border-left: 3px solid var(--accent-color); }
.upload-component { width: 100%; }
.card-preview { position: relative; width: 400px; height: 250px; margin-top: 15px; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
.card-preview img { width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0; z-index: 1; }
.card-preview .logo-overlay { position: absolute; top: 40px; left: 50%; transform: translateX(-50%); height: 40px; width: auto; z-index: 2; }
.card-preview .name-overlay { position: absolute; top: 87%; left: 30px; transform: translateY(-50%); color: white; font-family: 'OCR A Std', monospace, sans-serif; font-size: 0.9rem; text-transform: uppercase; text-shadow: 1px 1px 2px rgba(0,0,0,0.6); z-index: 2; }
.preview-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
.preview-table th, .preview-table td { border: 1px solid var(--border-color); padding: 8px 12px; vertical-align: top; text-align: left; }
.preview-table th { width: 30%; background-color: #f5f7fa; font-weight: bold; }
.step-nav { display: flex; justify-content: center; margin: 20px 0 30px; gap: 30px; }
.step { display: flex; flex-direction: column; align-items: center; gap: 5px; }
.step-number { width: 30px; height: 30px; border-radius: 50%; background: #CBD5E1; color: #475569; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 14px; }
.step-number.active { background: var(--primary-color); color: white; }
.step-label { font-size: 12px; color: var(--text-secondary); }
.step-label.active { color: var(--primary-color); font-weight: 500; }
.step-connector { width: 50px; height: 2px; background: #CBD5E1; align-self: center; }
.step-connector.active { background: var(--primary-color); }
.form-footer { display: flex; justify-content: space-between; margin-top: 30px; padding-top: 20px; border-top: 1px solid var(--border-color); }
.form-btn { padding: 10px 24px; border-radius: 6px; font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s; border: none; }
.btn-prev { background: #F1F5F9; color: var(--text-primary); }
.btn-prev:hover { background: #E2E8F0; }
.btn-next, .btn-submit { background: var(--primary-color); color: white; }
.btn-next:hover, .btn-submit:hover { background: #3B82F6; }
.query-dialog .el-form-item__content { justify-content: flex-start; }
.login-input { width: 100%; }
@media (max-width: 768px) { .part-a-grid { grid-template-columns: 1fr; } }
</style>